import { useState } from "react";
import "./FaqSection.css";

const faqData = [
  {
    question: "Can I use SingleLogin for my external clients?",
    answer:
      "Absolutely. The SingleLogin license allows you to build an application for personal or Business use or for a client. All you need is a User Licence to authorize your application or any user that requires access.",
  },
  {
    question: "Do I get free updates?",
    answer:
      "Yes. We automatically update all our applications with each deployed update, and constantly add new applications, pages, and features to our server.",
  },
  {
    question: "Is there a money back guarantee?",
    answer:
      "No! Our business is licence-driven. If you do not like our service, all you need to do is stop licence renewal or subscription. We have a 30 day free trial for all new businesses.",
  },
  {
    question: "Does it work with other programming languages?",
    answer:
      "Yes. SingleLogin is an authentication and authorization tool that provides a token after authentication. You can develop or integrate your application around this principle. If you want to enable deeper customization, you can integrate it into your assets pipeline or build processes.",
  },
];

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="pt-10 mb-5 faq-section" id="faq">
      <div className="container text-center">
        <span className="badge rounded-pill bg-primary-desat-soft mb-3">
          <span className="h6 text-uppercase">FAQ</span>
        </span>
      </div>
      <div className="section-header">
        <h2 className="section-title">
          Frequently <span className="highlight">Asked </span>Questions
        </h2>
        <p className="section-description">
          Get quick answers to frequently asked questions about using
          SingleLogin to streamline your work securely and efficiently.
        </p>
      </div>
      <div className="container pt-3 pt-md-5 text-left ">
        <div className="row faq-content">
          {faqData.map((item, index) => (
            <div className="" key={index}>
              <div
                className="d-flex align-items-start cursor-pointer"
                onClick={() => toggle(index)}
              >
                <div className="badge badge-lg badge-rounded-circle bg-primary me-4">
                  <span>?</span>
                </div>
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="text-black mb-0">{item.question}</h5>
                    <span className="toggle-icon ms-3 text-black">
                      {activeIndex === index ? "−" : "+"}
                    </span>
                  </div>
                  <div
                    className={`text-muted mt-2 collapse-content ${
                      activeIndex === index ? "show" : "hide"
                    }`}
                  >
                    {item.answer}
                  </div>
                </div>
              </div>
              <hr className="border-secondary opacity-25 mt-4" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
